module.exports = __webpack_public_path__ + "media/customizations/brookwaterlife/logo-new-59d570a3dd5652ed015f4b9e9ad42b48.png";